import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { fastCar, myCar } from '../assets/images';

const FinancementParticulierPage: React.FC = () => {
  const { t } = useTranslation();

  // Add type checking and fallback for situations array
  const situations: string[] = Array.isArray(t('financing.personal.situations', { returnObjects: true }))
    ? (t('financing.personal.situations', { returnObjects: true }) as string[])
    : [
        t('financing.personal.situation.uber'),
        t('financing.personal.situation.taxi'),
        t('financing.personal.situation.undeclaredIncome'),
        t('financing.personal.situation.latePayment'),
        t('financing.personal.situation.vehicleReturn'),
        t('financing.personal.situation.bankruptcy'),
        t('financing.personal.situation.socialAid'),
        t('financing.personal.situation.divorce'),
        t('financing.personal.situation.newResident'),
        t('financing.personal.situation.learnerPermit'),
        t('financing.personal.situation.internationalPermit'),
        t('financing.personal.situation.officialPeriod'),
        t('financing.personal.situation.jobLoss')
      ];

  return (
    <div className="pt-24">
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl font-bold text-primary-950 mb-6">
                {t('financing.personal.title')}
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                {t('financing.personal.intro')}
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-3.5 bg-black hover:bg-gray-900 text-white font-medium rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  <span>{t('contact.callUs')}</span>
                  <ArrowRight size={20} className="ml-2" />
                </Link>
                <Link
                  to="/financement/credit-alternatif"
                  className="inline-flex items-center justify-center px-8 py-3.5 border-2 border-black hover:bg-gray-50 text-black font-medium rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  {t('services.learnMore')}
                </Link>
              </div>
            </div>
            <div className="relative">
              <img 
                src={fastCar}
                alt="Fast car illustration"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Adaptée à vos besoins Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary-950 mb-6">
                {t('financing.personal.adapted.title')}
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                {t('financing.personal.adapted.description')}
              </p>
              <p className="text-lg text-gray-600 mb-8">
                {t('financing.personal.adapted.guidance')}
              </p>
              <div className="grid grid-cols-2 gap-4">
                {situations.map((situation: any, index: number) => (
                  <div key={index} className="flex items-center space-x-2">
                    <Check className="text-black flex-shrink-0" size={20} />
                    <span className="text-gray-700">{situation}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <img 
                src={myCar}
                alt="By my car illustration"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Score de crédit Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 md:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-primary-950 mb-6">
              {t('financing.personal.credit.title')}
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              {t('financing.personal.credit.description')}
            </p>
            <Link
              to="/contact"
              className="inline-block px-8 py-3.5 bg-black hover:bg-gray-900 text-white font-medium rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
            >
              {t('contact.contactUs')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FinancementParticulierPage;